module.exports = __webpack_public_path__ + "static/media/certyfikat-12.5c64b136.png";